import { ToggleButton, ToggleButtonGroup } from '@heroui/react'

/** One choice of a segmented HeroUI toggle group, kept chosen (never empty). */
export function Segments<T extends string>({
  label,
  value,
  items,
  disabled,
  onChange,
}: {
  label: string
  value: T
  items: readonly { id: T; label: string; title?: string }[]
  disabled?: boolean
  onChange: (value: T) => void
}) {
  return (
    <ToggleButtonGroup
      aria-label={label}
      size="sm"
      selectionMode="single"
      disallowEmptySelection
      isDisabled={disabled}
      selectedKeys={[value]}
      onSelectionChange={(keys) => {
        const next = [...keys][0]
        if (next !== undefined) onChange(String(next) as T)
      }}
    >
      {items.map((item, i) => (
        <ToggleButton key={item.id} id={item.id} aria-label={item.title ? `${item.label}, ${item.title}` : undefined}>
          {i > 0 && <ToggleButtonGroup.Separator />}
          <span title={item.title}>{item.label}</span>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
